export default __webpack_public_path__ + "static/media/noTestimonial.e5625ec4.svg";